import { createSignal, Accessor, Setter, createEffect } from 'solid-js';
import { createStore, SetStoreFunction } from 'solid-js/store'
import { view as api, ViewDefinition } from 'st-app/api';

export class ViewContext {
    viewId: Accessor<string>; setViewId: Setter<string>
    tabId: Accessor<string>; setTabId: Setter<string>
    primaryObjectGU: Accessor<string>; setPrimaryObjectGU: Setter<string>
    identity: Accessor<string>; setIdentity: Setter<string>
    
    definition: ViewDefinition | undefined = undefined
    private setDefinition: SetStoreFunction<ViewDefinition>

    events: any

    constructor() {
        [this.definition, this.setDefinition] = createStore<ViewDefinition>(new ViewDefinition());
        [this.viewId, this.setViewId] = createSignal('');
        [this.tabId, this.setTabId] = createSignal('');
        [this.primaryObjectGU, this.setPrimaryObjectGU] = createSignal('');
        [this.identity, this.setIdentity] = createSignal('');

        createEffect(async () => {
            if (!this.viewId()) return

            if (import.meta.env.DEV) {
                try {
                    const def = await api.LoadViewDefinition(this.viewId())
                    this.setDefinition(def)
                } catch (e) { console.error(e); }
            }
        })
    }
}
